import { all } from 'redux-saga/effects';

export function* dashboardRootSaga() {
    yield all([])
}